import { PureComponent } from 'react'
import { renderChildren } from '../children'

const fullscreenEvents = [
  'fullscreenchange',
  'mozfullscreenchange',
  'webkitfullscreenchange',
  'msfullscreenchange',
] as const

declare global {
  interface Document {
    msFullscreenElement?: Element
    mozFullScreenElement?: Element
    webkitFullscreenElement?: Element
  }
}

interface FullscreenHandlerProps {
  onFullscreenChange?: () => void
  children: ({
    fullscreenElement,
  }: {
    fullscreenElement: Element | null
  }) => React.ReactElement
}

interface State {
  fullscreenElement: Element | null
}

export default class FullscreenHandler extends PureComponent<
  FullscreenHandlerProps,
  State
> {
  state = {
    fullscreenElement: null,
  }

  componentDidMount() {
    this.checkFullscreenState()
    fullscreenEvents.forEach((eventName) =>
      document.addEventListener(eventName, this.checkFullscreenState),
    )
  }

  componentWillUnmount() {
    fullscreenEvents.forEach((eventName) =>
      document.removeEventListener(eventName, this.checkFullscreenState),
    )
  }

  checkFullscreenState = () => {
    const fullscreenElement =
      document.fullscreenElement ??
      document.mozFullScreenElement ??
      document.webkitFullscreenElement ??
      document.msFullscreenElement ??
      null

    this.setState({ fullscreenElement })
  }

  render() {
    const { children } = this.props
    const { fullscreenElement } = this.state

    return renderChildren(children, { fullscreenElement })
  }
}
